import { supabase, isSupabaseConfigured } from "./supabase";

// ---- Public (guest) ----

// Blocked/booked date ranges used to disable days in the calendar.
export async function getBlockedDates() {
  if (!isSupabaseConfigured) return [];
  const { data, error } = await supabase
    .from("blocked_dates")
    .select("id, room_id, start_date, end_date, reason");
  if (error) {
    console.error("getBlockedDates:", error.message);
    return [];
  }
  return data || [];
}

// Save a booking request (status defaults to 'pending').
export async function createBooking(booking) {
  if (!isSupabaseConfigured) return { error: "not_configured" };
  const { data, error } = await supabase
    .from("bookings")
    .insert(booking)
    .select()
    .single();
  if (error) console.error("createBooking:", error.message);
  return { data, error };
}

// ---- Admin (requires an authenticated session) ----

export async function listBookings() {
  if (!isSupabaseConfigured) return { data: [] };
  const { data, error } = await supabase
    .from("bookings")
    .select("*")
    .order("created_at", { ascending: false });
  return { data: data || [], error };
}

export async function addBlock(block) {
  if (!isSupabaseConfigured) return { error: "not_configured" };
  const { data, error } = await supabase
    .from("blocked_dates")
    .insert(block)
    .select()
    .single();
  return { data, error };
}

export async function deleteBlock(id) {
  if (!isSupabaseConfigured) return { error: "not_configured" };
  const { error } = await supabase.from("blocked_dates").delete().eq("id", id);
  return { error };
}

export async function updateBookingStatus(id, fields) {
  if (!isSupabaseConfigured) return { error: "not_configured" };
  const { error } = await supabase.from("bookings").update(fields).eq("id", id);
  return { error };
}
